export const addToFavorite = (film) => {
  return {
    type: "ADD_TO_FAVORITE",
    payload: {
      favorite: film,
    },
  };
};
